import { createFileRoute } from '@tanstack/react-router'
import { TeamPage } from '@/pages/team-members/team-page'

export const Route = createFileRoute('/team/members')({
  component: TeamPage,
})
